import { Component, Input, OnInit } from '@angular/core';
import { serviceCountSVG } from 'src/app/constants/svgs/service-count';
import { departmentCountSVG } from 'src/app/constants/svgs/department-count';
import { registrationCountSVG } from 'src/app/constants/svgs/registration-count';
import { transactionCountSVG } from 'src/app/constants/svgs/transaction-count';
import { AllStatistics } from '../../../models/statistics.model';
import { UtilsService } from 'src/app/services/utils.service';
import { serviceCountDarkSVG } from 'src/app/constants/svgs/service-count-dak';
import { departmentCountDarkSVG } from 'src/app/constants/svgs/department-count-dark';
import { registrationCountDarkSVG } from 'src/app/constants/svgs/registration-count-dark';
import { transactionCountDarkSVG } from 'src/app/constants/svgs/transaction-count-dark';

@Component({
  selector: 'app-statistics-section',
  templateUrl: './statistics-section.component.html',
  styleUrls: ['./statistics-section.component.scss'],
})
export class StatisticsSectionComponent implements OnInit {
  serviceCountSVG = serviceCountSVG;
  departmentCountSVG = departmentCountSVG;
  registrationCountSVG = registrationCountSVG;
  transactionCountSVG = transactionCountSVG;

  serviceCountDarkSVG = serviceCountDarkSVG;
  departmentCountDarkSVG = departmentCountDarkSVG;
  registrationCountDarkSVG = registrationCountDarkSVG;
  transactionCountDarkSVG = transactionCountDarkSVG;

  @Input() isLoading!: boolean;
  @Input() allStatistics!: AllStatistics;

  constructor(
    public utilSerivce:UtilsService
  ) {}

  ngOnInit() {}
}
